module.exports = __webpack_public_path__ + "media/images/athletes/1993-754836abbd9b09bb870333f8cc8a8169.png";